module.exports = __webpack_public_path__ + "ci.svg?8d61e66904da6870a111445bca7d363e";